import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Reload on stale dynamic-import failures (cache serving old chunk hashes).
// Throttle to once per 10s to avoid infinite reload loops.
const handleChunkError = (e?: Event) => {
  e?.preventDefault?.();
  const last = Number(sessionStorage.getItem("chunk-reload-ts") || 0);
  if (Date.now() - last > 10_000) {
    sessionStorage.setItem("chunk-reload-ts", String(Date.now()));
    window.location.reload();
  }
};
window.addEventListener("vite:preloadError", handleChunkError);
window.addEventListener("error", (e) => {
  const msg = String((e as ErrorEvent).message || "");
  if (msg.includes("Failed to fetch dynamically imported module") || msg.includes("Importing a module script failed")) {
    handleChunkError(e);
  }
});
window.addEventListener("unhandledrejection", (e) => {
  const msg = String((e as PromiseRejectionEvent).reason?.message || "");
  if (msg.includes("Failed to fetch dynamically imported module") || msg.includes("Importing a module script failed")) {
    handleChunkError();
  }
});

createRoot(document.getElementById("root")!).render(<App />);
